/** Fixed-size phone mockups; image loads never refresh or interrupt the carousel. */
export function phoneConversations(Splide) {
  document.querySelectorAll('[data-phone-conversations]').forEach((el) => {
    if (el.classList.contains('is-initialized')) return;
    const controls = el.querySelector('[data-phone-controls]');
    const prev = el.querySelector('[data-phone-prev]');
    const next = el.querySelector('[data-phone-next]');
    const splide = new Splide(el, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: '28px',
      arrows: false,
      pagination: true,
      speed: 450,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      keyboard: 'focused',
      breakpoints: {
        1023: { perPage: 2, gap: '24px' },
        639: { perPage: 1, fixedWidth: 'min(320px, calc(100vw - 64px))', gap: '18px' },
      },
      i18n: {
        prev: 'Předchozí rozhovor', next: 'Další rozhovor',
        first: 'První rozhovor', last: 'Poslední rozhovor',
        slideX: 'Přejít na rozhovor %s', pageX: 'Přejít na stránku %s',
        carousel: 'Konverzace', slide: 'Rozhovor',
        select: 'Vyber rozhovor', slideLabel: '%s z %s',
      },
    });
    const update = () => {
      prev.disabled = splide.index === 0;
      next.disabled = splide.index >= splide.Components.Controller.getEnd();
    };
    splide.on('mounted move updated refresh', update);
    prev.addEventListener('click', () => splide.go('<'));
    next.addEventListener('click', () => splide.go('>'));
    splide.mount();
    controls.hidden = false;
  });
}
